import styled from "styled-components";
import { HeadLine3 } from "../../../../components/typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 1200px;
`;

export const HeadWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  margin-top: 16px;
`;

export const PageTitle = styled(HeadLine3)`
  color: ${({ theme }) => theme.palette[900]};
`;

export const NavWrapper = styled.div`
  margin-bottom: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.palette[300]};
`;

export const TabContent = styled.div`
  padding: 24px 0;
`;

export const FormSection = styled.div`
  background-color: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 24px;
  max-width: 800px;
`;

export const FormRow = styled.div`
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  gap: 12px;
`;

export const QuotaGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
